import * as React from 'react';

import {Rating} from 'shells/entity/entity-display-values/rating';

import styles from './cell.module.css';

type Props = {
    value?: number;
};

export function CellRating(props: Props) {
    if (!props.value) {
        return null;
    }

    return (
        <div className={styles['cell-content']}>
            <Rating value={props.value} />
        </div>
    );
}
